<template>
  <div class="m-box">
    <header class="header" v-if="isWX">
      <img src="@/assets/news.svg" alt="" />
    </header>
    <section class="main">
      <h1 class="title" v-html="detailInfo.title">
      </h1>
      <div class="others">
        <p class="name">{{ detailInfo.source }}</p>
        <p class="pubtime">{{ detailInfo.pubDate }}</p>
      </div>
      <div
        class="topic"
        @click="topicClick(detailInfo.topicName, detailInfo.topicId)"
      >
        {{ detailInfo.topicName }}
      </div>
      <div class="con" v-html="detailInfo.content" ref="content"></div>
      <div class="bianji">
        <span v-if="detailInfo.editor_name">编辑：{{detailInfo.editor_name}}</span>
        <!-- <span>审核：</span> -->
      </div>
    </section>
    <section class="hot-post">
      <h1>
        <img src="@/assets/images/icon/hot-m.png" alt=""/><span>推荐阅读</span>
      </h1>
      <ul class="host-list">
        <li
          class="list-item"
          v-for="(item,index) in articleHotData"
          :key="index"
          v-if="index < 3"
          @click="toDetail(item.id,1,item.title,item.out_url)"
        >
          <div :class="item.focus_pic ? '' : 'block'">
            <p class="item-title">{{ item.title }}</p>
            <p class="item-time"><span>{{ item.source }}</span><span>{{ item.channel_name }}</span><span>{{ item.formatDateline }}</span></p>
          </div>
          <img v-if="item.focus_pic" :src="item.focus_pic" alt=""/>
        </li>
      </ul>
      <div class="dhhj-box">
        <div class="dhhj-title">大河画卷</div>
        <swiper :options="swiperOptions">
          <swiper-slide v-for="(slide, index) in slides"
        :key="index"><img class="dhhj-item" @click="toDetail(slide.id,2,slide.title,slide.out_url ? slide.out_url : slide.url)" :src="slide.focus_pic" alt=""></swiper-slide>
          <swiper-slide></swiper-slide>
        </swiper>
      </div>
      <ul class="host-list">
        <li
          class="list-item"
          v-for="(item,index) in articleHotData"
          :key="index"
          v-if="index > 2 && index < 6"
          @click="toDetail(item.id,1,item.title,item.out_url)"
        >
          <div :class="item.focus_pic ? '' : 'block'">
            <p class="item-title">{{ item.title }}</p>
            <p class="item-time"><span>{{ item.source }}</span><span>{{ item.channel_name }}</span><span>{{ item.formatDateline }}</span></p>
          </div>
          <img v-if="item.focus_pic" :src="item.focus_pic" alt=""/>
        </li>
      </ul>
      <div class="rdzt-box">
        <div class="rdzt-title">热点专题</div>
        <swiper :options="swiperOptions2">
          <swiper-slide v-for="(slide, index) in slides2"
        :key="index">
            <img class="rdzt-item" @click="toDetail(slide.id,3,slide.title,slide.out_url ? slide.out_url : slide.url)" :src="slide.focus_pic" alt="">
            <div class="zt-info" @click="toDetail(slide.id,3,slide.title,slide.out_url ? slide.out_url : slide.url)">
              <div class="zt-t">专题</div>
              <div class="zt-title">{{slide.title}}</div>
            </div>
          </swiper-slide>
          <swiper-slide></swiper-slide>
        </swiper>
      </div>
      <ul class="host-list">
        <li
          class="list-item"
          v-for="(item,index) in articleHotData"
          :key="index"
          v-if="index > 5 && index <9"
          @click="toDetail(item.id,1,item.title,item.out_url)"
        >
          <div :class="item.focus_pic ? '' : 'block'">
            <p class="item-title">{{ item.title }}</p>
            <p class="item-time"><span>{{ item.source }}</span><span>{{ item.channel_name }}</span><span>{{ item.formatDateline }}</span></p>
          </div>
          <img v-if="item.focus_pic" :src="item.focus_pic" alt=""/>
        </li>
      </ul>
      <div class="gg-box" v-for="(slide, index) in ggData"
        :key="index" @click="toDetail(slide.id,5,slide.title,slide.out_url ? slide.out_url : slide.url)">
        <img :src="slide.focus_pic" alt="">
        <span class="gg-t">广告</span>
      </div>

      <ul class="host-list">
        <li
          class="list-item"
          v-for="(item,index) in articleHotData"
          :key="index"
          v-if="index > 8"
          @click="toDetail(item.id,1,item.title,item.out_url)"
        >
          <div :class="item.focus_pic ? '' : 'block'">
            <p class="item-title">{{ item.title }}</p>
            <p class="item-time"><span>{{ item.source }}</span><span>{{ item.channel_name }}</span><span>{{ item.formatDateline }}</span></p>
          </div>
          <img v-if="item.focus_pic" :src="item.focus_pic" alt=""/>
        </li>
      </ul>
    </section>
    <footer v-if="isWX">
      <p>Copyright © 1996-{{ year }} DaHe</p>
      <p>NetworkMedia.Group All Rights Reserved</p>
    </footer>
    <div v-if="isWX" class="download">
      <div>
        <img src="/static/shareLogo.png" alt="大河网" />
        <span>下载大河网APP</span>
      </div>
      <a href="/m/download">立即下载</a>
    </div>
    <el-dialog :visible.sync="dialogTableVisible">
      <img :src="bigImgSrc" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import store from "@/store";
import DiscussList from "@/components/MDiscussList.vue";
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
Vue.use(preview);
export default {
  name: "MDetail",
  components: {
    DiscussList,
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 30,
        freeMode: true,
      },
      swiperOptions2: {
        slidesPerView: 1.231,
        spaceBetween: 30,
        freeMode: true,
      },
      slides:[],
      slides2:[],
      ggData:[],
      dialogTableVisible: false,
      isWX: false,
      currId: this.$route.params.id,
      currType: this.$route.params.type, //0:文章，1:活动
      detailInfo: {},
      userId: "",
      currUserId: "",
      attentionFlag: "",
      total: "",
      discussData: [],
      userInfo: {},
      token: store.state.UserToken || localStorage.getItem("UserToken") || "",
      year: new Date().getFullYear(),
      articleHotData: [],
      bigImgSrc: "",
      pages: 1,
      current: 1,
      rewardNum: "",
      isApp: false,
      channelId:''
    };
  },
  methods: {
    // // 大图预览
    // getImgSrc(e) {
    //   if(e.target.tagName.toUpperCase() === 'IMG') {
    //     this.dialogTableVisible = true
    //     this.bigImgSrc = e.target.src
    //   }
    // },
    getInfo() {
      this.$api["newPostsDatail"]({
        id: this.currId,
        type:this.currType
      }).then((res) => {
        this.detailInfo = res.data.data;
        this.getyfxFun(this.detailInfo.id,this.detailInfo.title,this.detailInfo.createTime)
        this.userId = res.data.data.userId;
        this.channelId = res.data.data.channel_id;
        this.attentionFlag = res.data.data.attentionFlag;
        this.wxshare(res.data.data.title.replace("<br>",""), res.data.data.summary, res.data.data.ifGrey);
        setTimeout(() => {
          const imgs = this.$refs.content.getElementsByTagName("img");
          for (let i = 0; i < imgs.length; i++) {
            const img = imgs[i];
            if(img.parentNode.tagName.toLowerCase() != 'a'){
              img.setAttribute("preview", 0);
              img.setAttribute("preview-text", "图片预览");
              this.$previewRefresh();
            }
          }
        }, 500);
        this.hotData();
      });
    },
    getyfxFun(id,title,time) {
      function formatDateToTimestamp(dateStr) {
          const date = new Date(dateStr);
          return date.getTime();
      }
      window._dhjs_self_appConfig = {
          /* 通用必填项 */
          appKey:'bec8e65467f44f86ba7d1ff2207aea18',
          isAPP:window.navigator.userAgent.includes('yydh_')?1:0,/* 1：客户端内访问 0：客户端外访问 必填  需自行各加结合app端头部自行区分window.navigator.userAgent.includes */
          /* 新闻详情页必填项 */
          newsID:id,//- 新闻id  必填
          newsTitle:title,//- 新闻标题 必填
          newsUrl:window.location.href,//- 新闻链接 必填
          pubTime:formatDateToTimestamp(time),//- 发布时间 时间戳（） 13位 必填
          /* 选填项 */
          pubChannel:'',//- 所属栏目
          newsSource:'',//- 新闻来源
          newsCompany:'',//- 新闻发布单位 依据数组中的名称填写 注:错误无效 ['河南日报社','大河网','顶端新闻','大河报','河南商报','河南法制报','期货日报','大河健康报','大河美术报','大河财立方','河南手机报','今日消费','河南日报农村版']
          newsLikeNum:'',//- 新闻点赞量 number/string
          newsCommentNum:'',//- 新闻评论量 number/string
          newsTransmitNum:'',//- 新闻转发量number/string
          newsCollect:'',//- 新闻收藏量number/string
          newsCommentContent:[],//- 新闻评论内容
      };
      (function () {
          var ma = document.createElement('script');
          ma.type = 'text/javascript';
          ma.async = true;
          ma.src = "https://uploads.dahe.cn/xrf/dhfx/index-dn.min.js";
          document.body.appendChild(ma);
      })();
    },
    //热帖
    hotData() {
      this.$api
        .c3NewsRecommend({channelId:this.channelId})
        .then((res) => {
          this.articleHotData = res.data.data;
        });
    },
    recommendOther() {
      this.$api
        .recommendOther()
        .then((res) => {
          // console.log(res)
          this.slides = res.data.data[0].c3NewsDtos;
          this.slides2 = res.data.data[1].c3NewsDtos;
          this.ggData = res.data.data[2].c3NewsDtos;
        });
    },
    //关注作者
    followBtn(id) {
      var obj = {
        authorId: id,
        isFollow: this.attentionFlag == 1 ? true : false,
      };
      let app = this.getEnv();
      if (app == "ios") {
        window.webkit.messageHandlers.follow.postMessage(obj);
      } else if (app == "android") {
        android.follow(id, obj.isFollow);
      }
    },
    //报名活动
    signUp(id) {
      var obj = {
        id: id,
        isFollow: false,
      };
      let app = this.getEnv();
      if (app == "ios") {
        window.webkit.messageHandlers.signUp.postMessage(obj);
      } else if (app == "android") {
        android.signUp(id, false);
      }
    },
    //进入个人主页
    headClick(uid) {
      var obj = {
        id: uid,
      };
      let app = this.getEnv();
      if (app == "ios") {
        window.webkit.messageHandlers.headClick.postMessage(obj);
      } else if (app == "android") {
        android.headClick(uid);
      }
    },
    //进入话题
    topicClick(name, id) {
      var obj = {
        topicName: name,
        topicId: id,
      };
      let app = this.getEnv();
      if (app == "ios") {
        window.webkit.messageHandlers.topicClick.postMessage(obj);
      } else if (app == "android") {
        android.topicClick(name, id);
      } else {
        window.open("/m/topic/" + id);
      }
    },
    getDiscussData() {
      // this.$api
      //   .appDiscussList({
      //     current: this.current,
      //     size: 10,
      //     type: this.currType,
      //     id: this.currId,
      //   })
      //   .then((res) => {
      //     this.total = res.data.data.total;
      //     this.pages = res.data.data.pages;
      //     // this.discussData = res.data.data.records;
      //     this.discussData = this.discussData.concat(res.data.data.records);
      //   });
    },
    discussMore() {
      this.current += 1;
      this.getDiscussData();
    },
    //判断环境
    getEnv() {
      let ua = window.navigator.userAgent.toLowerCase(),
        app = "";
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        app = "weixin";
      } else if (ua.indexOf("yydh_android") !== -1) {
        app = "android";
      } else if (ua.indexOf("yydh_ios") !== -1) {
        app = "ios";
      } else {
        app = "other";
      }
      return app;
    },
    getUserInfo() {
      let app = this.getEnv();
      this.isWX = false;
      if (app == "ios") {
        if (prompt("getInfo")) {
          this.token = JSON.parse(prompt("getInfo")).token;
          this.currUserId = JSON.parse(prompt("getInfo")).userId;
        } else {
          this.isWX = true;
        }
      } else if (app == "android") {
        if (android.getInfo()) {
          this.token = JSON.parse(android.getInfo()).token;
          this.currUserId = JSON.parse(android.getInfo()).userId;
        } else {
          this.isWX = true;
        }
      } else {
        this.isWX = true;
      }
      store.state.UserToken = this.token;
      localStorage.setItem("UserToken", this.token);
      this.getInfo();
    },
    changeFllow(bool) {
      if (bool) {
        this.attentionFlag = 1;
      } else {
        this.attentionFlag = 0;
      }
    },
    wxshare(t, d, ifGrey) {
      let sharelink = window.location.href;
      let sharetitle = t;
      let shareimgUrl = ifGrey == 1? "https://4g.dahe.cn/resources/img/wxlogo.png" : "https://4g.dahe.cn/resources/img/wxlogo1.png";
      let sharedes = d;

      let result = fetch(
        "https://share.dahe.cn/share/yanyu?url=" + encodeURIComponent(sharelink)
      );
      result
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          let text = data.object;

          /* 微信 */
          wx.config({
            debug: false, // 开启调试模式。
            appId: text.appId, // 必填，公众号的唯一标识
            timestamp: text.timestamp, // 必填，生成签名的时间戳
            nonceStr: text.nonceStr, // 必填，生成签名的随机串
            signature: text.signature, // 必填，签名
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
          });

          wx.checkJsApi({
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (res) {
              // console.log(res)
            },
          });

          //需在用户可能点击分享按钮前就先调用
          wx.ready(function () {
            // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            wx.updateAppMessageShareData({
              title: sharetitle, // 分享标题
              link: sharelink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareimgUrl, // 分享图标
              desc: sharedes, // 分享描述
              success: function () {
                // 设置成功
              },
            });

            // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
            wx.updateTimelineShareData({
              title: sharetitle, // 分享标题
              link: sharelink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareimgUrl, // 分享图标
              success: function () {
                // 设置成功
              },
            });
          });

          wx.error(function (res) {
            console.log("err: " + res);
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          });
        })
        .catch(function (ex) {
          console.log("failed", ex);
        });
    },
    scrollToDiscuss() {
      let height = document.getElementById("discussBox").offsetTop;
      window.scrollTo(0, height);
    },
    toDetail(tid,newsType,title,out_url) {
      var obj = {
          tid: tid,
          type: 1,
          newsType:newsType,
          title:title,
          url:out_url
        };
        let app = this.getEnv();
        if (app == "ios") {
          window.webkit.messageHandlers.toNewsDetail.postMessage(obj);
        } else if (app == "android") {
          android.toNewsDetail(tid,1,newsType,title,out_url);
        } else {
          if(newsType == 2 || newsType == 3 || newsType == 5 ) {
            window.open(out_url);
          }else{
            if(out_url) {
              window.open(out_url);
            }else{
              window.open("/m/newdetail/" + tid + "/" + 1);
            }
          }
        }
    },
    downloadMobile() {
      // let url = "YanYu://";
      // let UA = navigator.userAgent;
      // if(UA.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'){
      //   alert('请在浏览器中打开')
      // }else{
      //   if(navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)){
      //     window.location.href = url
      //   }else if(navigator.userAgent.match(/android/i)){
      //     this.iframeBridge('yanyu://bbs.dahe.cn/android')
      //   }
      // }
      var u = navigator.userAgent;
      var isWeixin = u.toLowerCase().indexOf("micromessenger") !== -1; // 微信内
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

      // 微信内
      if (isWeixin) {
        alert("请在浏览器中打开");
      } else {
        //android端
        if (isAndroid) {
          //安卓app的scheme协议
          window.location.href = "yanyu://bbs.dahe.cn/android";
          setTimeout(function () {
            let hidden =
              window.document.hidden ||
              window.document.mozHidden ||
              window.document.msHidden ||
              window.document.webkitHidden;
            if (typeof hidden == "undefined" || hidden == false) {
              //应用宝下载地址 (emmm 找不到淘宝应用宝的地址，这里放的是 lucky coffee 地址)
              window.location.href =
                "https://bbs.dahe.cn/app/%E7%9C%BC%E9%81%87%E5%A4%A7%E6%B2%B3.apk";
            }
          }, 2000);
        }
        //ios端
        if (isIOS) {
          //ios的scheme协议
          window.location.href = "YanYu://";
          setTimeout(function () {
            let hidden =
              window.document.hidden ||
              window.document.mozHidden ||
              window.document.msHidden ||
              window.document.webkitHidden;
            if (typeof hidden == "undefined" || hidden == false) {
              //App store下载地址
              window.location.href =
                "https://apps.apple.com/cn/app/%E7%9C%BC%E9%81%87%E5%A4%A7%E6%B2%B3/id933071401";
            }
          }, 2000);
        }
      }
    },
    iframeBridge(url) {
      let ifr = document.createElement("iframe");
      ifr.src = url;
      ifr.style.display = "none";
      document.body.appendChild(ifr);
      setTimeout(function () {
        document.body.removeChild(ifr);
      }, 1000);
    },
  },
  created() {
    this.isApp = this.getEnv() == 'ios' || this.getEnv() == 'android' ? false : true;
    this.getUserInfo();
    this.recommendOther();
    this.getDiscussData();
  },
  mounted: function () {
    window.fllowed = this.changeFllow;
    window.refreshComments = this.getDiscussData;
    window.scrollToDiscuss = this.scrollToDiscuss;
  },
  watch: {
    // $route(to, from) {
    //   (this.currId = this.$route.params.id), this.getInfo();
    //   window
    //   window.scrollTo(0,0);
    // }
  },
};
</script>

<style scoped lang="scss">
.m-box {
  max-width: 750px;
  width: 100%;
  margin: 0 auto 70px;
  height: auto;
  .header {
    background: linear-gradient(90deg, #317DFF 100%, #0b69f5 0%);
    text-align: center;
    padding: 6px 0;
    img {
      height: 39px;
      width: auto;
      display: block;
      margin: 0 auto;
    }
  }
  .main {
    border-top: 10px solid #f8f8f8;
    background: #fff;
    padding: 15px;
    .poster {
      position: relative;
      img {
        width: 100%;
        height: auto;
        max-height: 60vw;
        box-shadow: 2px -1px 2px rgba(0, 0, 0, 0.2);
        border-top-right-radius: 3px;
        border-top-left-radius: 3px;
      }
      span {
        position: absolute;
        top: 0;
        left: 0;
        color: #fff;
        background: linear-gradient(131deg, #4da0ff 0%, #1f71ce 100%);
        padding: 4px 8px;
        font-size: 12px;
        border-radius: 3px 0 8px 0;
        &.end {
          background: #ebebeb;
          color: #999999;
        }
      }
    }
    .title {
      font-size: 22px;
      font-weight: 600;
      color: #333333;
      line-height: 33px;
    }
    .others {
      // background: #f4f4f4;
      border-radius: 5px;
      display: flex;
      // justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      margin: 15px 0;
      position: relative;
      p {
        color: #999999;
        font-size: 15px;
        margin-right: 20px;
      }
      p:last-child {
        font-size: 15px;
        margin-right: 0;
      }
      &.bg-white {
        background: #fff;
        padding: 0;
        border-radius: 0;
        margin: 25px 0;
      }
      .mAdopt {
        position: absolute;
        width: 86px;
        height: 70px;
        top: 32px;
        right: 55px;
      }
      .user {
        display: flex;
        align-items: center;
        img {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          margin-right: 10px;
        }
        .name {
          color: #333333;
          line-height: 18px;
          font-size: 13px;
        }
        .pubtime {
          color: #999999;
          line-height: 16px;
          font-size: 11px;
        }
      }
      .attent-btn {
        border: 1px solid #317DFF;
        color: #317DFF;
        background: none;
        width: 60px;
        padding: 7px 0;
        &.visited {
          border: 1px solid #a2a2a2;
          color: #999;
        }
      }
      .wybm-btn {
        color: #fff;
        border: none;
        background: linear-gradient(90deg, #317DFF 100%, #0b69f5 0);
      }
      .ybm-btn {
        background: #ebebeb;
        color: #999999;
        border: none;
      }
    }
    .con {
      color: #333333;
      line-height: 28px;
      font-size: 18px;
      text-align: justify;
      padding-bottom: 15px;
      word-break: break-all;
      /deep/ img {
        display: block !important;
        max-width: 100% !important;
        margin: 0 auto 10px !important;
        height: auto !important;
      }
      /deep/ p {
        margin-bottom: 10px;
        word-break: break-all;
        font-size: 18px;
      }
      /deep/ iframe,
      /deep/ .video-iframe {
        width: 100%;
        height: 60vw;
        display: block;
      }
      @media screen and (min-width: 750px){
        /deep/ iframe,
        /deep/ .video-iframe {
          width: 720px;
          height: 450px;
          display: block;
        }
      }
    }
    .bianji {
      width: auto;
      color: #7b7b7b;
      font-size: 15px;
      text-align: right;
      span {
        margin-left: 15px;
      }
    }
    .topic {
      background: #e5effe;
      border-radius: 12px;
      width: fit-content;
      padding: 0 10px;
      font-size: 13px;
      line-height: 23px;
      color: #317DFF;
      margin-bottom: 10px;
    }
    .state-box {
      width: 100%;
      text-align: justify;
      font-size: 15px;
      color: #999999;
      text-align: justify;
      font-weight: 400;
      margin-top: 5.333vw;
      margin-top: 20px;
    }
    .reward {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 7.467vw 0 5.333vw 0;
      padding: 28px 0 18px 0;
      .reward-btn {
        width: 26.667vw;
        height: 9.6vw;
        max-width: 100px;
        max-height: 36px;
        background: #317DFF;
        border-radius: 6.133vw;
        text-align: center;
        // line-height: 9.6vw;
        color: #fff;
        // font-size: 4.267vw;
        font-size: 16px;
        font-weight: 500;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 4.267vw;
          height: 5.333vw;
          max-width: 16px;
          max-height: 20px;
          // margin-right: 1.333vw;
          margin-right: 8px;
        }
      }
    }
    .reward-list {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 9.6vw;
        height: 9.6vw;
        max-width: 36px;
        max-height: 36px;
        margin-right: 1.067vw;
        border-radius: 4.8vw;
      }
    }
    .reward-num {
      //       font-size: 15px;
      // font-weight: 400;
      // color: #999999;
      // line-height: 5.6vw;
      // margin-top: 2.667vw;
      // text-align: center;
      // margin-bottom: 3.467vw;
      font-size: 15px;
      font-weight: 400;
      color: #999999;
      line-height: 21px;
      margin-top: 10px;
      text-align: center;
      margin-bottom: 28px;
    }
  }
  .other-info {
    border-top: 10px solid #f8f8f8;
    background: #fff;
    padding-left: 20px;
    padding-bottom: 20px;
    p {
      line-height: 1.5;
      padding: 13px 13px 13px 0;
      border-bottom: 1px solid #d8d8d8;
      display: flex;
      justify-content: space-between;
      span {
        font-size: 16px;
        &:first-child {
          color: #999999;
        }
        i {
          display: inline-block;
          width: 22px;
          font-size: 18px;
        }
      }
    }
  }
  .discuss {
    .title {
      background: #f8f8f8;
      line-height: 2.2;
      padding: 0 15px;
      color: #8a8a8a;
      font-size: 15px;
      font-weight: 400;
      display: flex;
      justify-content: space-between;
    }
    .discuss-main {
      background: #fff;
      padding: 15px 0 30px 4vw;
      .no-discuss {
        color: #e6e6e6;
        text-align: center;
        margin-top: 20px;
        font-size: 17px;
        font-weight: bold;
        letter-spacing: 2px;
      }
      .discuss-more {
        color: #666;
        text-align: center;
        margin-top: 20px;
        font-size: 17px;
        // background: url("../../assets/images/m/discuss-more.png") no-repeat right center;
      }
      .open-app {
        background: #317DFF;
        color: #fff;
        display: block;
        border-radius: 2px;
        margin: 30px 15px 0;
        height: 39px;
        line-height: 39px;
        text-align: center;
        font-size: 14px;
      }
    }
  }
  .hot-post {
    border-top: 20px solid #f8f8f8;
    background: #fff;
    padding: 15px;
    .dhhj-box {
      width: 100%;
      margin-top: 10px;
      /* margin-bottom: 10px; */
      border-bottom: solid 1px #e0e1e2;
      padding-bottom: 10px;
      .dhhj-title {
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .swiper-wrapper {
        width: 32vw !important;
        height: 64.8vw;
        .swiper-slide {
          width: 32vw !important;
          height: 64.8vw;
          margin-right: 10px !important;
          .dhhj-item {
            width: 32vw;
            height: 64.8vw;
            object-fit:cover;
            border-radius: 2px;
          }
        }
        @media screen and (min-width: 750px){
          .swiper-slide {
            width: 240px !important;
            height: 486px;
            margin-right: 10px !important;
            .dhhj-item {
              width: 240px;
              height: 486px;
              object-fit:cover;
              border-radius: 2px;
            }
          }
        }
      }
    }
    .rdzt-box {
      width: 100%;
      margin-top: 10px;
      /* margin-bottom: 10px; */
      border-bottom: solid 1px #e0e1e2;
      padding-bottom: 10px;
      .rdzt-title {
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .swiper-wrapper {
        width: 82.4vw !important;
        height: 57.067vw;
        .swiper-slide {
          width: 82.4vw !important;
          height: 57.067vw;
          margin-right: 10px !important;
          .rdzt-item {
            width: 82.4vw;
            height: 57.067vw;
            border-radius: 10px;
            object-fit:cover
          }
          .zt-info {
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            .zt-t {
              width: 40px;
              line-height: 1.5;
              background: red;
              color: #fff;
              border-radius: 5px;
              text-align: center;
              font-size: 14px;
              margin-bottom: 5px;
              margin-left: 20px;
            }
            .zt-title {
              font-size: 16px;
              color: #fff;
              line-height: 2.5;
              padding: 0 20px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              box-sizing: border-box;
              background: linear-gradient(to top, #333333cc, transparent);
              border-radius: 10px;
            }
          }
        }
        @media screen and (min-width: 750px){
          .swiper-slide {
            width: 618px !important;
            height: 428px;
            margin-right: 10px !important;
            .rdzt-item {
              width: 618px;
              height: 428px;
              border-radius: 10px;
              object-fit:cover
            }
          }
        }
      }
    }
    .gg-box {
      width: 100%;
      height: 34.667vw;
      border-radius: 3px;
      position: relative;
      margin-top: 10px;
      padding-bottom: 10px;
      border-bottom: solid 1px #e0e1e2;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
        border-radius: 3px;
        object-fit:cover
      }
      .gg-t {
        position: absolute;
        left: 10px;
        bottom: 20px;
        font-size: 14px;
        color: #fff;
      }
    }
    @media screen and (min-width: 750px){
      .gg-box {
        width: 720px;
        height: 249px;
      }
    }
    h1 {
      font-weight: 600;
      color: #333333;
      font-size: 16px;
      display: flex;
      align-items: center;
      img {
        width: 15px;
        height: auto;
        margin-right: 7px;
      }
    }
    .list-item {
      display: flex;
      justify-content: space-between;
      padding: 15px 0;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        top: -50%;
        bottom: -50%;
        left: -50%;
        right: -50%;
        width: 200%;
        height: 200%;
        -webkit-transform: scale(0.5);
        transform: scale(0.5);
        border-bottom: solid 1px #e0e1e2;
        box-sizing: border-box;
      }
      &:last-child {
        border-bottom: none;
      }
      .item-title {
        font-size: 15px;
        color: #333;
        line-height: 1.3;
        text-align: justify;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .item-time {
        width: 100%;
        color: #999999;
        line-height: 18px;
        font-size: 13px;
        position: absolute;
        bottom: 0;
        left: 0;
        white-space: nowrap; /* 防止文本换行 */
        overflow: hidden; /* 隐藏超出容器的文本 */
        text-overflow: ellipsis; /* 超出部分显示省略号 */
        span {
          margin-right: 10px;
        }
      }
      div {
        width: 56.533vw;
        position: relative;
        &.block {
          width: 100%;
          max-width: 100%;
          .item-time {
            position: inherit;
          }
          .item-title {
            margin-bottom: 5px;
          }
        }
      }

      img {
        max-width: 113px;
        max-height: 80px;
        width: 30.133vw;
        height: 21vw;
        border-radius: 3px;
        margin-left: 15px;
      }
    }
  }
  footer {
    background: #333333;
    color: #eee;
    text-align: center;
    padding: 15px;
    p {
      line-height: 1.5;
      font-size: 14px;
    }
  }
  .download {
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    bottom: 0;
    width: 100%;
    max-width: 750px;
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    font-size: 14px;
    z-index: 2;
    div {
      display: flex;
      align-items: center;
      span {
        font-size: 16px;
      }
    }
    img {
      width: 40px;
      height: 40px;
      border-radius: 2px;
      margin-right: 10px;
    }
    a {
      background: #317DFF;
      height: 30px;
      line-height: 30px;
      color: #fff;
      padding: 0 10px;
      border-radius: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/m/Ndetail.vue